/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';
import './style.css';

export const LogoPartner = ({
    color,
    partner,
    size,
    className,
    bundesministerium = '/img/BMBFSFJ_gefoerdert_vom_deutsch_Web_c.svg',
    lernenDigital = '/img/lernen-digital-transferstelle-anthrazit-rgb-1.png',
}) => {
    return (
        <div
            className={`logo-partner ${partner} size-${size} color-${color} ${className}`}
        >
            {partner === 'bundesministerium' &&
                (color === 'default' || size === 'desktop') &&
                ['mobile', 'desktop'].includes(size) && (
                    <>
                        <img
                            className="bundesministerium-2"
                            alt="Bundesministerium"
                            src={bundesministerium}
                        />
                        <p className="aufbau-eines">
                            <span className="span">
                                Aufbau eines nachhaltigen Forschungs- und
                                Transferzentrums: Digitalisierung in der
                                Lehrerbildung wird im Rahmen der gemeinsamen „
                            </span>
                            <a
                                href="https://www.qualitaetsoffensive-lehrerbildung.de/"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                <span className="text-wrapper-5">
                                    Qualitätsoffensive Lehrerbildung“{' '}
                                </span>
                            </a>
                            <span className="text-wrapper-6">
                                von Bund und Ländern aus Mitteln des
                                Bundesministeriums für Bildung und Forschung
                                unter dem Förderkennzeichen 01JA2009 gefördert.
                            </span>
                        </p>
                    </>
                )}

            {[
                'EU-vertical',
                'EU',
                'lernen-digital',
                'uni-t-b',
                'vector-shiftung',
            ].includes(partner) && (
                <img
                    alt="De finanziert von"
                    style={{ height: '30px' }}
                    src={
                        partner === 'EU' && color === 'default'
                            ? '/img/de-finanziert-von-der-europn-ischen-union-pos-1.png'
                            : color === 'default' && partner === 'EU-vertical'
                              ? '/img/en-funded-by-european-union-vert-rgb-neg-1.png'
                              : color === 'default' &&
                                  partner === 'lernen-digital'
                                ? lernenDigital
                                : color === 'white' &&
                                    partner === 'lernen-digital'
                                  ? '/img/lernen-digital-transferstelle-white-rgb-1.png'
                                  : color === 'default' &&
                                      partner === 'vector-shiftung'
                                    ? '/img/vector-stiftung-wb-marke-rgb-schutzraum-1.png'
                                    : partner === 'vector-shiftung' &&
                                        color === 'white'
                                      ? '/img/vector-stiftung-wb-marke-rgb-schutzraum-white-1.png'
                                      : partner === 'EU-vertical' &&
                                          color === 'white'
                                        ? '/img/en-funded-by-european-union-vert-rgb-white-1.png'
                                        : partner === 'uni-t-b' &&
                                            color === 'white'
                                          ? '/img/universitaettuebingen-wortbildmarke-white-1.png'
                                          : partner === 'uni-t-b' &&
                                              color === 'black'
                                            ? '/img/universitaettuebingen-wortbildmarke-black-1.png'
                                            : color === 'default' &&
                                                partner === 'uni-t-b'
                                              ? '/img/universitaettuebingen-wortbildmarke-1.png'
                                              : partner === 'EU' &&
                                                  color === 'white' &&
                                                  size === 'mobile'
                                                ? '/img/de-finanziert-von-der-europn-ischen-union-white-1-1.png'
                                                : '/img/de-finanziert-von-der-europn-ischen-union-white-1.png'
                    }
                />
            )}

            {color === 'white' &&
                partner === 'bundesministerium' &&
                size === 'mobile' && (
                    <div className="frame-11">
                        <img
                            className="bundesministerium-3"
                            alt="Bundesministerium"
                            src="/img/BMBFSFJ_gefoerdert_vom_deutsch_Web_c.svg"
                        />
                        <p className="aufbau-eines-2">
                            <span className="text-wrapper-7">
                                Aufbau eines nachhaltigen Forschungs- und
                                Transferzentrums: Digitalisierung in der
                                Lehrerbildung wird im Rahmen der gemeinsamen „
                            </span>
                            <a
                                href="https://www.qualitaetsoffensive-lehrerbildung.de/"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                <span className="text-wrapper-7">
                                    Qualitätsoffensive Lehrerbildung“{' '}
                                </span>
                            </a>
                            <span className="text-wrapper-7">
                                von Bund und Ländern aus Mitteln des
                                Bundesministeriums für Bildung und Forschung
                                unter dem Förderkennzeichen 01JA2009 gefördert.
                            </span>
                        </p>
                    </div>
                )}
        </div>
    );
};

LogoPartner.propTypes = {
    color: PropTypes.oneOf(['white', 'default']),
    partner: PropTypes.oneOf([
        'bundesministerium',
        'EU',
        'uni-t-b',
        'EU-vertical',
        'lernen-digital',
        'vector-shiftung',
    ]),
    size: PropTypes.oneOf(['desktop', 'mobile']),
    bundesministerium: PropTypes.string,
    lernenDigital: PropTypes.string,
};
